export const Base64 = {
  encode: (data: string): string => btoa(data),
  decode: (data: string): string => atob(data),
};
